import React from 'react';
import { MaskText, Reveal, SectionLabel } from './ui/Reveal';
import { MagneticButton } from './ui/MagneticButton';
import { brand, images } from '../data/site';
export function AboutPreview() {
  return <section className="bg-surface2 py-20 sm:py-28" aria-label="About Morvix" data-id="element-35" data-mp="tu9z2p2bpk5z">
      <div className="mx-auto w-full max-w-container px-5 sm:px-8" data-id="element-36" data-mp="ysben00jj1cp">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:items-center" data-id="element-37" data-mp="yupa39z4ufks">
          <Reveal data-id="element-38" data-mp="1miz24tmxvzkd">
            <figure data-id="element-39" data-mp="1mkjk7js2hq1c">
              <img src={images.poster} alt="Abstract editorial composition using Morvix brand shapes and colour" className="w-full object-cover" loading="lazy" decoding="async" data-id="element-40" data-mp="1qjiwxqk1ir3c" />
              <figcaption className="label mt-3 text-muted" data-id="element-41" data-mp="1hpcpv2kotxp3">
                Studio composition — {brand.parent}
              </figcaption>
            </figure>
          </Reveal>

          <div data-id="element-42" data-mp="2a9b9o3e9vuaf">
            <SectionLabel data-id="element-43" data-mp="2a9uqfgs6scmv">The studio</SectionLabel>
            <h2 className="mt-5 max-w-2xl font-display text-4xl font-extrabold uppercase leading-[0.9] tracking-tightest sm:text-6xl" data-id="element-44" data-mp="1f0ial68xcsyo">
              <MaskText text="Great businesses|deserve to look|like it." data-id="element-45" data-mp="1b1jabyy51kdk" />
            </h2>
            <p className="mt-7 max-w-xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-46" data-mp="1oso2yh339cee">
              Most businesses don’t have a product problem — they have a communication problem. Poor
              design makes a strong company look weak, outdated or untrustworthy. Morvix exists to
              close that gap: turning ideas into visual systems that build credibility and stay
              memorable.
            </p>
            <p className="mt-5 max-w-xl font-serif text-xl italic leading-snug sm:text-2xl" data-id="element-47" data-mp="27nl8bw5s0znv">
              Design isn’t decoration. It communicates, differentiates, persuades and lasts.
            </p>
            <div className="mt-9" data-id="element-48" data-mp="ddraex7p452a">
              <MagneticButton to="/about" variant="outline" cursorLabel="About us" showArrow data-id="element-49" data-mp="8dmw9du9fmf8">
                More About Morvix
              </MagneticButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}